import { Paper, Typography } from "@mui/material"


export const StatCard = (
  props: {
    title: string,
    value: string,
    date: string,
    link: string,
    linkText: string,
    icon?: any
  }
) => {
  return (
    <Paper
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        height: 220,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        {
          props.icon ? (
            <>
              <div style={{
                marginRight: '7px'
              }}>
                {props.icon}
              </div>
            </>
          ) : null
        }
        <Typography component="h2" variant="h6" color="primary" fontWeight={"bold"}>
          {props.title}
        </Typography>
      </div>
      <Typography component="p" variant="h4">
        {props.value}
      </Typography>
      <Typography color="text.secondary" sx={{ flex: 1 }}>
        Data: {props.date}
      </Typography>
    </Paper>
  )
}
